import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class FileTypeSearchCriteria extends ValueObject {
    
    public searchCriteria: string = "";
}